import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, formatErr, imgSrc } from "@/lib/api";

const fmt = (iso) => new Date(iso).toLocaleString("pl-PL", { dateStyle: "medium", timeStyle: "short" });
const FILTERS = ["oczekuje", "zatwierdzona", "odrzucona", "wszystkie"];

const Card = ({ r, onAction }) => (
  <article className={`inq ${r.status === "oczekuje" ? "nowe" : ""}`} data-testid={`review-card-${r.id}`}>
    <div className="inq-head">
      <h3>{r.name}{r.occasion && <em style={{ color: "var(--gold)" }}> · {r.occasion}</em>}</h3>
      <span className="label">{fmt(r.created_at)} · {r.status}</span>
    </div>
    <div className="stars">{"★".repeat(r.rating)}<span>{"★".repeat(5 - r.rating)}</span></div>
    <pre>{r.text}</pre>
    {r.photos?.length > 0 && (
      <div className="photo-list" data-testid={`review-photos-${r.id}`}>
        {r.photos.map((p) => <a key={p} className="photo-thumb" href={imgSrc(p)} target="_blank" rel="noreferrer"><img src={imgSrc(p)} alt="" /></a>)}
      </div>
    )}
    <div className="inq-tools">
      {r.status !== "zatwierdzona" && <button className="mini" onClick={() => onAction(r.id, "approve")} data-testid={`review-approve-${r.id}`}>Zatwierdź i opublikuj</button>}
      {r.status === "oczekuje" && <button className="mini" onClick={() => onAction(r.id, "reject")} data-testid={`review-reject-${r.id}`}>Odrzuć</button>}
      <button className="mini danger" onClick={() => window.confirm("Usunąć tę opinię?") && onAction(r.id, "delete")} data-testid={`review-delete-${r.id}`}>Usuń</button>
    </div>
  </article>
);

export const Reviews = () => {
  const [list, setList] = useState(null);
  const [filter, setFilter] = useState("oczekuje");

  useEffect(() => { api.get("/reviews").then(({ data }) => setList(data)).catch((e) => toast.error(formatErr(e))); }, []);

  const act = async (id, action) => {
    try {
      if (action === "delete") { await api.delete(`/reviews/${id}`); setList((l) => l.filter((x) => x.id !== id)); toast.success("Usunięto"); return; }
      const { data } = await api.post(`/reviews/${id}/${action}`);
      setList((l) => l.map((x) => (x.id === id ? data : x)));
      toast.success(action === "approve" ? "Opinia opublikowana na stronie" : "Opinia odrzucona");
    } catch (e) { toast.error(formatErr(e)); }
  };

  if (!list) return <p className="adm-sub">Ładowanie…</p>;
  const shown = filter === "wszystkie" ? list : list.filter((r) => r.status === filter);

  return (
    <div data-testid="admin-reviews">
      <h1>Opinie od klientów</h1>
      <p className="adm-sub">Opinie wysłane przez formularz na stronie. Zatwierdzona opinia trafia na początek sekcji „Opinie klientów” – później możesz ją edytować w zakładce Treść strony.</p>
      <div className="filters" style={{ marginTop: 28 }}>
        {FILTERS.map((s) => <button key={s} className={`tab${filter === s ? " on" : ""}`} onClick={() => setFilter(s)} data-testid={`review-filter-${s}`}>{s} ({s === "wszystkie" ? list.length : list.filter((r) => r.status === s).length})</button>)}
      </div>
      <div className="inq-list">
        {shown.length ? shown.map((r) => <Card key={r.id} r={r} onAction={act} />) : <p className="adm-sub" data-testid="reviews-empty">Brak opinii.</p>}
      </div>
    </div>
  );
};
